export default "__VITE_ASSET__49fdad46__"